import { Field } from 'factorial-form'

export const getFirstError = (field: Field) => {
  return field.errors ? field.errors[0] : ''
}
